class PrefetchService {
  prefetchImages(urls: string[]): void {
    urls.forEach(url => {
      const img = new Image();
      img.src = url;
    });
  }
}

export const prefetchService = new PrefetchService();
